import React from 'react';
import { FaSun, FaMoon, FaDesktop } from 'react-icons/fa';
import { useTheme } from '../hooks/useTheme';
import styles from '../styles/ThemeToggle.module.css';

const ICONS = {
  dark: <FaMoon size={13} />,
  light: <FaSun size={13} />,
  system: <FaDesktop size={13} />,
};

const LABELS = {
  dark: 'Dark mode',
  light: 'Light mode',
  system: 'System preference',
};

const ThemeToggle = () => {
  const { mode, cycle } = useTheme();
  return (
    <button
      className={styles.toggle}
      onClick={cycle}
      aria-label={`Current: ${LABELS[mode]}. Click to cycle.`}
      title={LABELS[mode]}
    >
      {ICONS[mode]}
    </button>
  );
};

export default ThemeToggle;
